import * as Sentry from '@sentry/nextjs';
import {Integration} from '@sentry/types';

import {beforeSend, udSentry} from '@udemy/sentry';
import {UDData} from '@udemy/ud-data';

const getSentryDsn = () => {
    return process.env.SENTRY_DSN as string;
};

export const getSentryOptions = () => {
    const DEPLOY_ENV = process.env.DEPLOY_ENV as string;

    return {
        beforeSend,
        dsn: getSentryDsn(),
        environment: DEPLOY_ENV === 'prod' ? 'PROD' : 'DEV',
        whitelistUrls: DEPLOY_ENV === 'prod' ? [/udemy\.com/] : [/./],
        sampleRate: DEPLOY_ENV === 'prod' ? 0.05 : 1,
        autoSessionTracking: false,
        integrations: [] as Integration[],
        release: process.env.VERSION,
    };
};

export const initializeSentry = () => {
    if (process.env.DEPLOY_ENV === 'local') {
        return;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    udSentry.initializeSentry(Sentry as any, getSentryOptions());
};

export const getSentryContext = (data: UDData) => {
    const udConfig = data.Config;
    const userAgnosticTrackingParams = data.userAgnosticTrackingParams;

    return {
        app_name: process.env.APP_NAME,
        brand: udConfig.brand?.identifier,
        js_bundle: 'nextJS',
        page_key: userAgnosticTrackingParams?.page_key || `${udConfig.app_name}-without-page-key`,
        user_id: data.me.is_authenticated ? data.me.id.toString() : undefined,
        version: process.env.VERSION,
    };
};

/**
 * Initialize Sentry client context after UD data is available.
 */
export function initializeSentryClient(udData: UDData) {
    if (process.env.DEPLOY_ENV !== 'local') {
        udSentry.initializeSentryContext(getSentryContext(udData));
    }
}
